import { createStore } from 'vuex'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      if (
        state.sidebarVisible != '' ||
        sessionStorage.getItem('mobileView') != 'true'
      ) {
        state.sidebarVisible = payload.value
      }
    },
    setModalProperties(state, modalData) {
      state.modalMessage = modalData.modalMessage
      state.modalTitle = modalData.modalTitle
      state.action = modalData.action
    }
  },
  actions: {},
  modules: {}
})
